import React, { FunctionComponent, useContext } from 'react';
import {
  PageHeader,
  Content,
  ResponsivePadding,
  Group,
  ResponsiveMargin,
  Button,
} from '../../components';
import { BrandStore, RegistrationStore } from '../../context';
import { history } from '../../history';
import { Documents } from './Documents';
import { registrationIsConditionalApproved } from '../../util/registration.util';

export const conditionalApprovalValues = {
  body: 'The following documents are required for business and signer verification.',
};

export const StandaloneDocumentsPage: FunctionComponent = () => {
  const {
    state: { brand },
  } = useContext(BrandStore);

  const {
    state: { registration },
  } = useContext(RegistrationStore);

  let { regStandaloneDocumentsHeader, regStandaloneDocumentsBody } =
    brand || {};

  const isConditionallyApproved =
    registrationIsConditionalApproved(registration);
  if (isConditionallyApproved) {
    regStandaloneDocumentsBody = conditionalApprovalValues.body;
  }
  return (
    <>
      <PageHeader
        header={regStandaloneDocumentsHeader}
        id="standalone-documents-page-header"
        data-testid="standalone-documents-page-header"
        description={<p>{regStandaloneDocumentsBody}</p>}
      />
      <Content>
        <Documents accept="image/jpeg,image/jpg,image/png,application/pdf,.pdf,.jpeg,.jpg,.png" />
      </Content>
      <Content>
        <ResponsivePadding desktop="0 200px 0 0" mobile="1rem">
          <Group justify="end">
            <ResponsiveMargin mobile="1rem 0" desktop="3rem 0rem">
              <Button
                icon="fas fa-chevron-right"
                motif="success"
                id="documents-continue-button"
                data-testid="documents-continue-button"
                onClick={
                  // if conditionally approved, show the confirmation screen
                  // without the pizza tracker
                  isConditionallyApproved
                    ? () => history.push('/documents/confirmation')
                    : // after submit, push to pizza tracker page
                      // and prevent merchant switcher modal from auto-opening
                      () =>
                        history.push(
                          `/tracker?ms=${btoa(
                            JSON.stringify({
                              modalState: 'closed',
                            }),
                          )}`,
                        )
                }
              >
                <span>Submit</span>
              </Button>
            </ResponsiveMargin>
          </Group>
        </ResponsivePadding>
      </Content>
    </>
  );
};
